import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
const Table = forwardRef<HTMLTableElement, React.HTMLAttributes<HTMLTableElement>>(({
  className,
  ...props
}, ref) => <div className="relative w-full overflow-auto" data-id="element-682">
    <table ref={ref} className={cn('w-full caption-bottom text-sm', className)} {...props} data-id="element-683" />
  </div>);
Table.displayName = 'Table';
const TableHeader = forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(({
  className,
  ...props
}, ref) => <thead ref={ref} className={cn('[&_tr]:border-b', className)} {...props} data-id="element-684" />);
TableHeader.displayName = 'TableHeader';
const TableBody = forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(({
  className,
  ...props
}, ref) => <tbody ref={ref} className={cn('[&_tr:last-child]:border-0', className)} {...props} data-id="element-685" />);
TableBody.displayName = 'TableBody';
const TableFooter = forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(({
  className,
  ...props
}, ref) => <tfoot ref={ref} className={cn('border-t bg-slate-100/50 font-medium [&>tr]:last:border-b-0', className)} {...props} data-id="element-686" />);
TableFooter.displayName = 'TableFooter';
const TableRow = forwardRef<HTMLTableRowElement, React.HTMLAttributes<HTMLTableRowElement>>(({
  className,
  ...props
}, ref) => <tr ref={ref} className={cn('border-b transition-colors hover:bg-slate-100/50 data-[state=selected]:bg-slate-100', className)} {...props} data-id="element-687" />);
TableRow.displayName = 'TableRow';
const TableHead = forwardRef<HTMLTableCellElement, React.ThHTMLAttributes<HTMLTableCellElement>>(({
  className,
  ...props
}, ref) => <th ref={ref} className={cn('h-10 px-2 text-left align-middle font-medium text-slate-500 [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]', className)} {...props} data-id="element-688" />);
TableHead.displayName = 'TableHead';
const TableCell = forwardRef<HTMLTableCellElement, React.TdHTMLAttributes<HTMLTableCellElement>>(({
  className,
  ...props
}, ref) => <td ref={ref} className={cn('p-2 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]', className)} {...props} data-id="element-689" />);
TableCell.displayName = 'TableCell';
export { Table, TableHeader, TableBody, TableFooter, TableRow, TableHead, TableCell };